// extracted by mini-css-extract-plugin
module.exports = {"button_primary":"ButtonPrimary_button_primary__2KQpk","button_primary_inverse":"ButtonPrimary_button_primary_inverse__yY--W"};